import { render } from "./PartnerBig2.vue?vue&type=template&id=5fe585a1"
import script from "./PartnerBig2.vue?vue&type=script&lang=js"
export * from "./PartnerBig2.vue?vue&type=script&lang=js"

import "./PartnerBig2.vue?vue&type=style&index=0&id=5fe585a1&lang=css"

import exportComponent from "C:\\Development\\konnektor\\scores\\kon-platform-wallboards-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__